import { Injectable } from '@angular/core';
import { CanActivate, Router } from '@angular/router';
import { ToastrService } from 'ngx-toastr';
import { AuthService } from '../../../authentication/shared/services/auth.service';
import { UserService } from '../services/user.service';
import { Observable, of } from 'rxjs';
import { map, catchError } from 'rxjs/operators';

@Injectable({
  providedIn: 'root'
})
export class AuthGuard implements CanActivate {
  constructor(
    private authService: AuthService,
    private router: Router,
    private toastr: ToastrService,
    private userService: UserService
  ) {}

  canActivate(): Observable<boolean> | boolean {
    if (!this.authService.isLoggedIn()) {
      this.toastr.error('You must be logged in to access this page.');
      this.router.navigate(['/signin']);
      return false;
    }

    // Check if user data already exists
    const currentUser = this.userService.getCurrentUser();
    if (currentUser) {
      return true;
    }

    // If no user data, load it
    return this.userService.loadUser().pipe(
      map(() => true),
      catchError(() => {
        this.toastr.error('Failed to load user data');
        this.userService.clearUser();
        localStorage.clear();
        this.router.navigate(['/signin']);
        return of(false);
      })
    );
  }

  canActivateChild(): Observable<boolean> | boolean {
    return this.canActivate();
  }

  canDeactivate(): Observable<boolean> | boolean {
    return this.canActivate();
  }

  canLoad(): Observable<boolean> | boolean {
    return this.canActivate();
  }
}